export const EndChatReasonType = Object.freeze({
  endByCustomer: "1",
  endByAstrologer: "2",
  endByExpiredTimer: "3"
})